//@ts-nocheck
import { FC, useEffect, useMemo, useState } from 'react'
import CustomSelect from '../../../../custom_components/CustomSelect'
import useContacts from '../../../../hooks/useContacts'
import { ScheduleTask } from '../../../../hooks/useOnBoardSchedule'
import MissionService from '../../../../../../service/MissionService'
import useUrlParams from '../../../../hooks/useUrlParams'
import ModalInput from '../../../../../MissionModelling/commonComponents/ModalInput'

const TaskType = [
    { label: "Upload File", value: "file" },
    { label: "Payload Task", value: "payload" },
    { label: "Adhoc Task", value: "adhoc" },
    { label: "Upload Schedule", value: "schedule" },
];

const TaskForm = ({ onFormSubmit }) => {

    const { sat_id } = useUrlParams()
    const { allOnBoardSchedule } = useContacts()
    const [taskType, setTaskType] = useState<{ label: string, value: string } | null>(null)
    const [allTaskOptions, setAllTaskOptions] = useState<{ label: string, value: any }[]>([])
    const [selected_task, set_selected_task] = useState<{ label: string, value: any } | null>(null)
    const [selected_schedule, set_selected_schedule] = useState<{ label: string, value: ScheduleTask } | null>(null)

    const [fileType, setFileType] = useState<{ label: string; value: string } | null>(null);
    const [appId, setAppId] = useState<{ label: string; value: string } | null>(null);
    const [fileId, setFileId] = useState<{ label: string; value: string } | null>(null);
    const [destinationId, setDestinationId] = useState<{ label: string; value: string } | null>(null);
    const [mtuValue, setMtuValue] = useState<any>(1300);
    const [delayValue, setDelayValue] = useState<any>(200);
    const [activityTimeoutValue, setActivityTimeoutValue] = useState<any>(200);
    const [connectionTimeoutValue, setConnectionTimeoutValue] = useState<any>(200);
    const [isLossDetection, setIsLossDetection] = useState(true);
    const [isFormValid, setIsFormValid] = useState(false);
    const [fileName, setFileName] = useState('');
    const [fileObject, setFileObject] = useState(null);

    // Validation effect
    useEffect(() => {
        const isValid = !!(
            fileName &&
            appId &&
            fileId &&
            mtuValue &&
            delayValue &&
            activityTimeoutValue &&
            connectionTimeoutValue
        );
        setIsFormValid(isValid);

        // Prepare form data whenever any field changes
        const formData = {
            fileName,
            fileObject,
            appId,
            fileId,
            mtuValue,
            delayValue,
            activityTimeoutValue,
            connectionTimeoutValue,
            isLossDetection
        };
        // Pass data to parent component
        onFormSubmit(isValid, formData);
    }, [
        fileName, appId, fileId,
        mtuValue, delayValue, activityTimeoutValue,
        connectionTimeoutValue, isLossDetection
    ]);
    const PLANED_SCHEDULE = useMemo(() => {
        return allOnBoardSchedule.Planned && allOnBoardSchedule.Planned.map((schedule) => ({ label: schedule.ScheduleName, value: schedule }))
    }, [allOnBoardSchedule])

    const get_adhoc_task = async () => {
        if (!sat_id) return
        try {
            const response = await MissionService.getAllTask(sat_id)
            const all_task: any[] = response.data
            if (!all_task) return
            const adhoc_tasks: { label: string, value: any }[] = response.data.filter((task: any) => task.taskType === "Adhoc")
                .map((task: any) => ({ label: task.taskName, value: task }))
            setAllTaskOptions(adhoc_tasks)

        } catch (error) {
            console.error(error)
        } finally {
            const selected_task = sessionStorage.getItem('selected_task') ? JSON.parse(sessionStorage.getItem('selected_task') || '{}') : null
            const selected_schedule = sessionStorage.getItem('selected_schedule') ? JSON.parse(sessionStorage.getItem('selected_schedule') || '{}') : null
            set_selected_task({
                label: selected_task?.taskName,
                value: selected_task
            })
            set_selected_schedule({
                label: selected_schedule?.ScheduleName,
                value: selected_schedule
            })
        }
    }

    useEffect(() => {
        get_adhoc_task()
    }, [sat_id])

    const handleFileUpload = () => {
        const fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.accept = '.txt'; // Accept only .txt files
        fileInput.onchange = (event: any) => {
            const file = event.target.files[0];
            if (file && file.type === 'text/plain') {
                const reader = new FileReader();
                reader.onload = (e: any) => {
                    if (!e) return;
                    const uploadFile = e.target.result;
                    const blob = new Blob([uploadFile], { type: "multipart/form-data" });
                    const file_data = new FormData();
                    file_data.append("file", blob, file.name);
                    file_data.append("scenarioId", scenario_id as string);
                    file_data.append("trueTwinId", truetwin_id as string);
                    file_data.append("bandType", "Backdoor");
                    file_data.append("insertTime", "")
                    file_data.append("groundStationId", "")
                    // Call the upload API with the FormData object
                    setFileName(file.name);
                    uploadAPI(file_data);
                };
                reader.readAsText(file);
            } else {
                console.error('Invalid file format');
                toast.error('Invalid file format. Please upload a .txt file.', { toastId: '0' });
            }
        };
        fileInput.click();
    };

    return (
        <div className="left__panel__body__form__section__container">
            <div className="left__panel__body__input__option__container">
                <span className="input__label">Task Type</span>
                <div className='input__box__container'>
                    <CustomSelect options={TaskType} value={taskType} onChange={(e) => {
                        setTaskType(e)
                        sessionStorage.setItem('taskType', e.value)
                    }} placeholder='Select Task Type' disabled_search={true} />
                    <span className='input__feedback'></span>
                </div>
            </div>
            {taskType?.value === 'adhoc' &&
                <div className="left__panel__body__input__option__container">
                    <span className="input__label">Task</span>
                    <div className='input__box__container'>
                        <CustomSelect options={allTaskOptions} value={selected_task} onChange={(e) => {
                            set_selected_task(e)
                            sessionStorage.setItem('selected_task', JSON.stringify(e.value))
                        }} disabled_search={true} />
                        <span className='input__feedback'></span>
                    </div>
                </div>
            }
            {taskType?.value === 'schedule' &&
                <div className="left__panel__body__input__option__container">
                    <span className="input__label">Schedule</span>
                    <div className='input__box__container'>
                        <CustomSelect options={PLANED_SCHEDULE} value={selected_schedule} onChange={(e) => {
                            set_selected_schedule(e)
                            sessionStorage.setItem('selected_schedule', JSON.stringify(e.value))
                        }} disabled_search={true} />
                        <span className='input__feedback'></span>
                    </div>
                </div>
            }

            {taskType?.value === "file" && (
                <div className="glass-card">
                    {/* File Upload */}
                    <div className="input-group">
                        {/* <span className="input-label">File</span> */}
                        <div className="file-upload-wrapper">
                            <input
                                type="file"
                                id="fileUpload"
                                className="file-input"
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                    if (file) {
                                        const reader = new FileReader();
                                        reader.onload = (readerEvent) => {
                                            const uploadFile = readerEvent.target.result;
                                            // Create Blob with multipart/form-data type
                                            const blob = new Blob([uploadFile], { type: "multipart/form-data" });
                                            const file_data = new FormData();
                                            file_data.append("file", blob, file.name);
                                            setFileName(file.name);
                                            setFileObject(file_data);
                                        };
                                        // Read file as ArrayBuffer (maintains binary data)
                                        reader.readAsArrayBuffer(file);
                                    } else {
                                        setFileName('');
                                        setFileObject(null);
                                    }
                                }}
                            />
                            <label htmlFor="fileUpload" className="file-upload-button">
                                Choose File
                            </label>
                            <span className="file-name-display">
                                {fileName || 'No file chosen'}
                            </span>
                        </div>
                    </div>

                    {/* App ID / File ID / Destination ID */}
                    {[
                        { label: 'App ID', value: appId, onChange: e => setAppId(e.target.value) },
                        { label: 'File Name', value: fileId, onChange: e => setFileId(e.target.value) },
                        // { label: 'Destination ID', value: destinationId, onChange: e => setDestinationId(e.target.value) },
                    ].map(({ label, value, onChange }) => (
                        <div
                            key={label}
                            className="input-group"
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '16px',
                                marginBottom: '11px'  // Optional spacing between rows
                            }}
                        >
                            <span className="input-label" style={{ minWidth: '120px' }}>{label}</span>
                            <input
                                type="text"
                                className="text-input"
                                placeholder={`Enter ${label}`}
                                value={value}
                                onChange={onChange}
                                style={{ flex: 1 }}
                            />
                        </div>
                    ))}
                    <div style={{
                        height: '1px',
                        backgroundColor: 'rgba(240, 240, 240, 0.10)',
                        margin: '20px 0'
                    }} />


                    {/* MTU, Delay, Timeouts */}
                    {[
                        { label: 'Max Transmission unit', value: mtuValue, onChange: e => setMtuValue(e.target.value), unit: 'B' },
                        { label: 'Delay', value: delayValue, onChange: e => setDelayValue(e.target.value), unit: 'ms' },
                        { label: 'Activity Timeout', value: activityTimeoutValue, onChange: e => setActivityTimeoutValue(e.target.value), unit: 'sec' },
                        { label: 'Connection Timeout', value: connectionTimeoutValue, onChange: e => setConnectionTimeoutValue(e.target.value), unit: 'sec' },
                    ].map(({ label, value, onChange, unit }) => (
                        <div key={label} className="input-group">
                            <span className="input-label">{label}</span>
                            <div className="input-with-unit mt-2">
                                <input
                                    type="number"
                                    className="number-input"
                                    placeholder={`Enter ${label.toLowerCase()}`}
                                    value={value}
                                    onChange={onChange}
                                />
                                <span className="unit">{unit}</span>
                            </div>
                        </div>
                    ))}

                    {/* Loss Detection Toggle */}
                    <div className="input-group">
                        <span className="input-label">Loss Detection</span>

                        <button className={`custom__toggle__btn__container ${isLossDetection && 'active'}`} onClick={() => setIsLossDetection(!isLossDetection)} style={{ marginLeft: "25px" }} />

                    </div>

                </div>
            )}
        </div>
    )
}

export default TaskForm